module.exports = __webpack_public_path__ + "static/media/giant_paper_straw4.c8465211.png";